import { AfterViewInit, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

/**
 * Alerta de exito estandarizada (check animado + mensaje + badge opcional +
 * hasta 2 acciones). Se presenta via ComponentsService.showSuccessAlert() como un
 * modal flotante compacto (cssClass 'success-alert-modal'), no como una pantalla mas
 * del flujo -- para usarse en cualquier lugar de la app donde se cree/edite algo y se
 * quiera confirmar con el mismo lenguaje visual.
 */
@Component({
    selector: 'app-success-alert',
    templateUrl: './success-alert.component.html',
    styleUrls: ['./success-alert.component.scss'],
})
export class SuccessAlertComponent implements AfterViewInit {
    @Input() title = '¡Listo!';
    @Input() message = '';
    @Input() badgeIcon = 'clipboard-outline';
    @Input() badgeLabel?: string;
    @Input() badgeValue?: string;
    @Input() hint?: string;
    @Input() primaryText?: string;
    @Input() secondaryText = 'Cerrar';

    visible = false;

    constructor(public modalController: ModalController) { }

    ngAfterViewInit(): void {
        requestAnimationFrame(() => { this.visible = true; });
    }

    primary(): void {
        this.modalController.dismiss('primary');
    }

    secondary(): void {
        this.modalController.dismiss('secondary');
    }
}
